import MUITextField from "@mui/material/TextField";

const TextField = MUITextField;

export default TextField;
